import * as React from "react";
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
const SvgPIssues = (props) => /* @__PURE__ */ _jsxs("svg", {
	viewBox: "0 0 20 20",
	fill: "none",
	xmlns: "http://www.w3.org/2000/svg",
	...props,
	children: [
		/* @__PURE__ */ _jsx("path", {
			d: "M7.88342 22C7.37716 22 6.96676 21.5896 6.96676 21.0833L6.96676 16.5C6.96676 15.9937 7.37716 15.5833 7.88342 15.5833H10.6334C11.1397 15.5833 11.5501 15.9937 11.5501 16.5L11.5501 21.0833C11.5501 21.5896 11.1397 22 10.6334 22H7.88342Z",
			fill: "#1D7D74"
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M7.88342 3.66667C7.37716 3.66667 6.96676 3.25626 6.96676 2.75L6.96676 0.916667C6.96676 0.410406 7.37716 1.42336e-07 7.88342 1.20207e-07L10.6334 0C11.1397 -2.21294e-08 11.5501 0.410406 11.5501 0.916667L11.5501 2.75C11.5501 3.25626 11.1397 3.66667 10.6334 3.66667H7.88342Z",
			fill: "#1D7D74"
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M0 5.86595C0 5.25844 0.492487 4.76595 1.1 4.76595H16.7715C17.0669 4.76595 17.3499 4.88475 17.5567 5.09561L21.2439 8.85394C21.6636 9.28175 21.6636 9.96682 21.2439 10.3946L17.5567 14.153C17.3499 14.3638 17.0669 14.4826 16.7715 14.4826H1.1C0.492489 14.4826 0 13.9901 0 13.3826V5.86595Z",
			fill: "#2AAB9F"
		})
	]
});
export default SvgPIssues;
